(function () {
  // Mix karton (6.10.2026.): klik doda po 3 ili 6 limenki svakog okusa i otvori košaricu.
  // Stavke ispisuje snippets/ekipa-mix.liquid u data-items na gumbu.
  //
  // Animacija (7.10.2026.): dok traje jedan POST na /cart/add.js, iz slike kartona
  // izleti točno toliko malih limenki koliko ih ide u košaricu (12 ili 24), u boji
  // svog okusa, i sleti na brojač košarice koji raste za jedan po limenci.
  // Na košaricu se prelazi tek kad su gotovi i zahtjev i animacija. Stilovi su u
  // assets/ekipa-mix.css; uz prefers-reduced-motion limenke ne lete nego se samo
  // pojave i nestanu na kartonu (CSS), a brojač i dalje raste po jedan.
  var FLIGHT_MS = 750;
  var LAUNCH_SPREAD_MS = 1100; // sve limenke krenu unutar ovog vremena
  var MAX_STAGGER_MS = 80;
  var AFTER_LAND_MS = 350;
  var MAX_WAIT_MS = 4000; // ako animationend izostane (skrivena kartica), ne čekaj vječno

  function showError(btn, text) {
    var box = btn.parentNode && btn.parentNode.querySelector('[data-ekipa-mix-error]');
    if (box) {
      box.textContent = text;
      box.hidden = false;
    }
  }

  function parseJSON(value) {
    try {
      return JSON.parse(value || '[]');
    } catch (err) {
      return [];
    }
  }

  function isOnScreen(el) {
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && r.bottom > 0 && r.right > 0 &&
      r.top < window.innerHeight && r.left < window.innerWidth;
  }

  function currentCount() {
    var el = document.querySelector('[data-ekipa-cart-count]');
    var n = el ? parseInt(el.textContent, 10) : 0;
    return isNaN(n) ? 0 : n;
  }

  // Brojač u zaglavlju često nije na ekranu kad je kupac skrolao do kartona.
  // Tada limenke slijeću u privremeni brojač gore desno.
  function findTarget(startCount) {
    var candidates = document.querySelectorAll('[data-ekipa-cart-badge], [data-ekipa-sticky-cart]');
    for (var i = 0; i < candidates.length; i++) {
      if (!candidates[i].hidden && isOnScreen(candidates[i])) return { el: candidates[i], temp: false };
    }
    var pill = document.createElement('div');
    pill.className = 'ekipa-mix-fly-target';
    pill.setAttribute('aria-hidden', 'true');
    pill.innerHTML = 'Košarica <span data-ekipa-mix-fly-count></span>';
    pill.querySelector('[data-ekipa-mix-fly-count]').textContent = startCount;
    document.body.appendChild(pill);
    return { el: pill, temp: true };
  }

  function bump(el) {
    el.classList.remove('is-ekipa-mix-bump');
    void el.offsetWidth;
    el.classList.add('is-ekipa-mix-bump');
  }

  function animateCans(btn, items, icons, onDone) {
    var source = btn.querySelector('[data-ekipa-mix-source]') || btn;
    var from = source.getBoundingClientRect();
    var startCount = currentCount();
    var target = findTarget(startCount);
    var to = target.el.getBoundingClientRect();
    var toX = to.left + to.width / 2;
    var toY = to.top + to.height / 2;

    // Redoslijed lansiranja: red po red, u svakom redu okusi slijeva nadesno,
    // kao što stoje u kartonu.
    var columns = items.length;
    var rows = 0;
    items.forEach(function (it) { rows = Math.max(rows, it.quantity || 0); });
    var queue = [];
    for (var r = 0; r < rows; r++) {
      for (var c = 0; c < columns; c++) {
        if (r < (items[c].quantity || 0)) queue.push({ row: r, col: c });
      }
    }

    var stagger = Math.min(MAX_STAGGER_MS, LAUNCH_SPREAD_MS / Math.max(queue.length, 1));
    var landed = 0;
    var flying = [];
    var timers = [];
    var cancelled = false;

    queue.forEach(function (slot, i) {
      timers.push(setTimeout(function () {
        if (cancelled) return;
        var x = from.left + from.width * (0.24 + slot.col * (0.52 / Math.max(columns - 1, 1)));
        var y = from.top + from.height * (0.62 - slot.row * (0.34 / Math.max(rows - 1, 1)));
        var can = document.createElement('img');
        can.className = 'ekipa-mix-fly';
        can.alt = '';
        can.src = icons[slot.col] || '';
        can.style.left = x + 'px';
        can.style.top = y + 'px';
        can.style.setProperty('--dx', (toX - x) + 'px');
        can.style.setProperty('--dy', (toY - y) + 'px');
        can.style.setProperty('--lift', (60 + Math.random() * 60) + 'px');
        can.style.setProperty('--rot', (Math.random() * 30 - 15) + 'deg');
        can.style.animationDuration = FLIGHT_MS + 'ms';
        can.addEventListener('animationend', function () {
          can.remove();
          if (cancelled) return;
          landed++;
          var n = startCount + landed;
          if (target.temp) {
            target.el.querySelector('[data-ekipa-mix-fly-count]').textContent = n;
          } else if (window.ekipaUpdateCartBadges) {
            window.ekipaUpdateCartBadges(n);
          }
          bump(target.el);
          if (landed === queue.length) {
            timers.push(setTimeout(function () {
              if (target.temp) target.el.remove();
              onDone();
            }, AFTER_LAND_MS));
          }
        });
        document.body.appendChild(can);
        flying.push(can);
      }, i * stagger));
    });

    return function cancel() {
      cancelled = true;
      timers.forEach(clearTimeout);
      flying.forEach(function (el) { el.remove(); });
      if (target.temp) target.el.remove();
      if (window.ekipaUpdateCartBadges) window.ekipaUpdateCartBadges(startCount);
    };
  }

  // Male slike limenki učitaj unaprijed, da prve u letu ne budu prazne.
  document.addEventListener('DOMContentLoaded', function () {
    var seen = {};
    document.querySelectorAll('[data-ekipa-mix-add]').forEach(function (btn) {
      parseJSON(btn.getAttribute('data-icons')).forEach(function (url) {
        if (url && !seen[url]) {
          seen[url] = true;
          new Image().src = url;
        }
      });
    });
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ekipa-mix-add]');
    if (!btn || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
    e.preventDefault();

    var items = parseJSON(btn.getAttribute('data-items'));
    if (!items.length) return;
    var icons = parseJSON(btn.getAttribute('data-icons'));

    btn.setAttribute('aria-busy', 'true');
    var errorBox = btn.parentNode && btn.parentNode.querySelector('[data-ekipa-mix-error]');
    if (errorBox) errorBox.hidden = true;

    var animationDone = new Promise(function (resolve) {
      btn._ekipaMixCancel = animateCans(btn, items, icons, resolve);
      setTimeout(resolve, MAX_WAIT_MS);
    });

    var request = fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        return r.json().then(function (body) {
          if (!r.ok) throw new Error(body.description || body.message || 'Greška');
          return body;
        });
      })
      .then(function () {
        return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); });
      });

    request
      .then(function (cart) {
        return animationDone.then(function () { return cart; });
      })
      .then(function (cart) {
        if (window.ekipaUpdateCartBadges && window.ekipaCanCount) {
          window.ekipaUpdateCartBadges(window.ekipaCanCount(cart));
        }
        if (window.ekipaCartSync) window.ekipaCartSync.broadcast(cart);
        window.location.href = btn.getAttribute('data-cart-url') || '/cart';
      })
      .catch(function (err) {
        if (btn._ekipaMixCancel) btn._ekipaMixCancel();
        btn._ekipaMixCancel = null;
        btn.removeAttribute('aria-busy');
        showError(btn, 'Karton trenutno nije moguće dodati: ' + err.message);
      });
  });
})();
